import { AppConfig } from './app-config.interface';
import { appConfigFromDomFactory } from './util';

export const appConfig: AppConfig = appConfigFromDomFactory();
